import ConfigurableCalendar, { IOwnProps as IConfigurableCalendarOwnProps } from './ConfigurableCalendar'

export default ConfigurableCalendar
export { IConfigurableCalendarOwnProps }
